import React, { useEffect, useState } from "react";
import Parse from "parse";
import axios from "axios";
import Title from "./Title";
// import Alert from "../primitives/Alert";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMessage } from "../hook/showMessage";
import PhoneInput from "react-phone-input-2";

const AddUser = (props) => {
  const { userId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { showMessage } = useMessage();
  const currentUser = location.state?.user;
  const action = location.state?.action;
  const isEdit = action === "Edit";
  const isView = action === "View";
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  // const [isUserExist, setIsUserExist] = useState(false);
  const parseBaseUrl = localStorage.getItem("baseUrl");
  const parseAppId = localStorage.getItem("parseAppId");
  const updatedUser = {
    ...currentUser,
    name,
    email,
    phone
  };
  // Populate form if user exists (for view/edit)
  useEffect(() => {
    if (currentUser) {
      setName(currentUser?.name || currentUser.Name || "");
      setEmail(currentUser?.email || currentUser.Email || "");
      setPhone(currentUser?.phone || currentUser.Phone || "");
    }
  }, [currentUser]);

  const checkUserExist = async () => {
    try {
      const res = await Parse.Cloud.run("getUserDetails", {
        email: email,
        userId: userId
      });
      if (res) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLoader(true);
    try {
      if (isEdit) {
        await handleEditUser();
      } else {
        await handleAddUser();
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setIsLoader(false);
    }
  };

  const handleEditUser = async () => {
    if (!userId) {
      showMessage({
        type: "warning",
        title: "Warning",
        message: "User not found"
      });
      return;
    }
    try {
      // Update user in contracts_Users if exists
      const contractRes = await Parse.Cloud.run("editContractUser", {
        userId: userId,
        name,
        email,
        phone
      });
      if (!contractRes?.success) {
        throw contractRes;
      }
      //  Update user in _User
      const userRes = await Parse.Cloud.run("editUser", {
        userId: userId,
        name,
        email,
        phone
      });
      if (!userRes?.success) {
        throw userRes;
      }
      showMessage({
        type: "success",
        title: "Success",
        message: "User updated successfully"
      });
      // Navigate to the user view page
      navigate(`/users/view/${userId}`, {
        state: { user: updatedUser, action: "View" }
      });
    } catch (error) {
      // Duplicate email
      if (error.code === 202) {
        showMessage({
          type: "error",
          title: "Warning",
          message: "This email address is already in use"
        });
        return;
      }
      // Known backend message
      if (error?.message) {
        showMessage({
          type: "error",
          title: "Error",
          message: error.message
        });
        return;
      }
      // Fallback
      showMessage({
        type: "error",
        title: "Error",
        message: "Failed to update user"
      });
    }
  };

  // Define a function to handle form submission
  const handleAddUser = async () => {
    const res = await checkUserExist();
    if (res) {
      // setIsUserExist(true);
      console.log(res);
      setIsLoader(false);
      showMessage({
        type: "warning",
        title: "Warning",
        message: "User already exists!"
      });
      return;
      // setTimeout(() => {
      //   setIsUserExist(false);
      // }, 3000);
    } else {
      try {
        const contactQuery = new Parse.Object("contracts_Users");
        contactQuery.set("Name", name);
        contactQuery.set("Phone", phone);
        contactQuery.set("Email", email);
        contactQuery.set("UserRole", "contracts_User");

        if (localStorage.getItem("TenantId")) {
          contactQuery.set("TenantId", {
            __type: "Pointer",
            className: "partners_Tenant",
            objectId: localStorage.getItem("TenantId")
          });
        }

        try {
          const _users = Parse.Object.extend("User");
          const _user = new _users();
          _user.set("name", name);
          _user.set("username", email);
          _user.set("email", email);
          _user.set("phone", phone);
          _user.set("password", phone);

          const user = await _user.save();
          if (user) {
            const roleurl = `${parseBaseUrl}functions/AddUserToRole`;
            const headers = {
              "Content-Type": "application/json",
              "X-Parse-Application-Id": parseAppId,
              sessionToken: localStorage.getItem("accesstoken")
            };
            const body = {
              appName: localStorage.getItem("_appName"),
              roleName: "contracts_User",
              userId: user.id
            };
            await axios.post(roleurl, body, { headers: headers });
            const currentUser = Parse.User.current();
            contactQuery.set(
              "CreatedBy",
              Parse.User.createWithoutData(currentUser.id)
            );

            contactQuery.set("UserId", user);
            const acl = new Parse.ACL();
            acl.setPublicReadAccess(true);
            acl.setPublicWriteAccess(true);
            acl.setReadAccess(currentUser.id, true);
            acl.setWriteAccess(currentUser.id, true);

            contactQuery.setACL(acl);

            const res = await contactQuery.save();

            const parseData = JSON.parse(JSON.stringify(res));
            if (props.details) {
              props.details({
                value: parseData[props.valueKey],
                label: parseData[props.displayKey]
              });
            }
            if (props.closePopup) {
              props.closePopup();
            }
            if (props.handleUserData) {
              props.handleUserData(parseData);
            }

            setIsLoader(false);
            showMessage({
              type: "success",
              title: "Success",
              message: "User created successfully"
            });
            setName("");
            setPhone("");
            setEmail("");
            // Navigate to the user view page
            navigate(`/users/view/${user.id}`, {
              state: { user: updatedUser, action: "View" }
            });
          }
        } catch (err) {
          console.log("err ", err);
          if (err.code === 202) {
            const params = { email: email };
            const userRes = await Parse.Cloud.run("getUserId", params);
            const roleurl = `${parseBaseUrl}functions/AddUserToRole`;
            const headers = {
              "Content-Type": "application/json",
              "X-Parse-Application-Id": parseAppId,
              sessionToken: localStorage.getItem("accesstoken")
            };
            const body = {
              appName: localStorage.getItem("_appName"),
              roleName: "contracts_User",
              userId: userRes.id
            };
            await axios.post(roleurl, body, { headers: headers });
            const currentUser = Parse.User.current();
            contactQuery.set(
              "CreatedBy",
              Parse.User.createWithoutData(currentUser.id)
            );

            contactQuery.set("UserId", {
              __type: "Pointer",
              className: "_User",
              objectId: userRes.id
            });
            const acl = new Parse.ACL();
            acl.setPublicReadAccess(true);
            acl.setPublicWriteAccess(true);
            acl.setReadAccess(currentUser.id, true);
            acl.setWriteAccess(currentUser.id, true);

            contactQuery.setACL(acl);
            const res = await contactQuery.save();

            const parseData = JSON.parse(JSON.stringify(res));
            if (props.details) {
              props.details({
                value: parseData[props.valueKey],
                label: parseData[props.displayKey]
              });
            }
            if (props.closePopup) {
              props.closePopup();
            }
            if (props.handleUserData) {
              props.handleUserData(parseData);
            }
            setIsLoader(false);
            setName("");
            setPhone("");
            setEmail("");
          }
        }
      } catch (err) {
        // console.log("err", err);
        setIsLoader(false);
        alert("something went wrong!");
      }
    }
  };

  // Define a function to handle the "add yourself" checkbox
  const handleReset = () => {
    setName("");
    setPhone("");
    setEmail("");
  };

  return (
    <div className="shadow-md rounded my-2 p-3 bg-[#ffffff] md:border-[1px] md:border-gray-600/50">
      <Title title={action} User />
      {/* {isUserExist && <Alert type="danger">User already exists!</Alert>} */}
      {isLoader && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-30 z-50">
          <div
            style={{
              fontSize: "45px",
              color: "#3dd3e0"
            }}
            className="loader-37"
          ></div>
        </div>
      )}
      <div className="w-full mx-auto">
        <form onSubmit={handleSubmit}>
          <h1 className="text-[20px] font-semibold mb-4">
            {" "}
            {action === "View" ? "User Details" : `${action} User`}
          </h1>
          <div className="mb-3">
            <label
              htmlFor="name"
              className="block text-xs text-gray-700 font-semibold"
            >
              Name
              <span style={{ color: "red", fontSize: 13 }}> *</span>
            </label>
            <input
              type="text"
              id="name"
              value={name}
              disabled={isView}
              onChange={(e) => setName(e.target.value)}
              required
              className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
            />
          </div>
          <div className="mb-3">
            <label
              htmlFor="email"
              className="block text-xs text-gray-700 font-semibold"
            >
              Email
              <span style={{ color: "red", fontSize: 13 }}> *</span>
            </label>
            <input
              type="email"
              id="email"
              value={email}
              disabled={isView}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="px-3 py-2 w-full border-[1px] border-gray-300 rounded focus:outline-none text-xs"
            />
          </div>
          <div className="mb-3">
            <label
              htmlFor="phone"
              className="block text-xs text-gray-700 font-semibold"
            >
              Phone
              <span style={{ color: "red", fontSize: 13 }}> *</span>
            </label>
            <PhoneInput
              country={"it"} // Set default country code
              value={phone}
              id="phone"
              onChange={(value) => setPhone("+" + value)}
              inputStyle={{
                width: "100%",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "10px",
                paddingLeft: "45px",
                fontSize: "14px"
              }}
              required
            />
          </div>
          {action !== "View" && (
            <div className="flex items-center mt-3 gap-2 text-white">
              <button
                type="submit"
                className="bg-[#3F464B] rounded-sm shadow-md text-[13px] font-semibold uppercase text-white py-1.5 px-2.5 focus:outline-none"
              >
                Submit
              </button>
              <div
                type="button"
                onClick={() => handleReset()}
                className="bg-[#188ae2] rounded-sm shadow-md text-[13px] font-semibold uppercase text-white py-1.5 px-2.5 text-center ml-[2px] focus:outline-none"
              >
                Reset
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddUser;
